import CheckBoxCustom from '../../../../atoms/checkbox/CheckBox'
import InputCustom from '../../../../atoms/input/InputCustom'
import TextArea from '../../../../atoms/textarea/TextArea'
import styles from '../index.module.scss'
import { Grid, Typography } from '@mui/material'
import { useState } from 'react'

const CeremonyModal = () => {
	const [ceremonyData, setCeremonyData] = useState({})
	return (
		<>
			<div className={styles.header}>
				<h3>Ceremony Details</h3>
			</div>

			<div className={`${styles.formWrp} ${styles.ceremonyForm}`}>
				<Grid container spacing={1.5}>
					<Grid size={{ xs: 12, md: 12 }}>
						<div className={styles.formField}>
							<label
								htmlFor="Ceremony Duration (estimated)"
								className={styles.label}
							>
								Ceremony Duration (estimated)
							</label>
							<InputCustom
								type="text"
								name="ceremonyDuration"
								id="ceremonyDuration"
								placeholder="e.g., 30 minutes"
								value={ceremonyData.ceremonyDuration}
								onChange={(e) =>
									setCeremonyData({
										...ceremonyData,
										ceremonyDuration: e.target.value,
									})
								}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 12 }}>
						<div className={styles.checkFormField}>
							<Typography variant="h4">Vows</Typography>
							<ul>
								<li>
									<CheckBoxCustom
										name="personalVows"
										id="personalVows"
										lineColor="#ffffffb0"
										label={
											<span
												style={{
													marginTop: '2px',
													display: 'inline-block',
												}}
											>
												Personal (longer)
											</span>
										}
										value={ceremonyData.personalVows}
										onChange={(e) =>
											setCeremonyData({
												...ceremonyData,
												personalVows: e.target.value,
											})
										}
									/>
								</li>
								<li>
									<CheckBoxCustom
										name="preCannedVows"
										id="preCannedVows"
										lineColor="#ffffffb0"
										label={
											<span>Pre-canned (shorter)</span>
										}
										value={ceremonyData.vows}
										onChange={(e) =>
											setCeremonyData({
												...ceremonyData,
												vows: e.target.value,
											})
										}
									/>
								</li>
							</ul>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 12 }}>
						<div className={styles.formField}>
							<label
								htmlFor="numberOfReadings"
								className={styles.label}
							>
								Number of Readings (For every reading, add 5
								minutes)
							</label>
							<InputCustom
								type="text"
								name="numberOfReadings"
								id="numberOfReadings"
								placeholder="0"
								value={ceremonyData.numberOfReadings}
								onChange={(e) =>
									setCeremonyData({
										...ceremonyData,
										numberOfReadings: e.target.value,
									})
								}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 12 }}>
						<div className={styles.formField}>
							<label
								htmlFor="religiousElements"
								className={styles.label}
							>
								Religious Elements
							</label>
							<TextArea
								placeholder="Write something..."
								value={ceremonyData.religiousElements}
								onChange={(e) =>
									setCeremonyData({
										...ceremonyData,
										religiousElements: e.target.value,
									})
								}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 12 }}>
						<div className={styles.formField}>
							<label
								htmlFor="partyProcessionalSize"
								className={styles.label}
							>
								Party/Processional Size (Long party/processional
								will increase time)
							</label>
							<InputCustom
								type="text"
								name="partyProcessionalSize"
								id="partyProcessionalSize"
								placeholder="3"
								value={ceremonyData.partyProcessionalSize}
								onChange={(e) =>
									setCeremonyData({
										...ceremonyData,
										partyProcessionalSize: e.target.value,
									})
								}
							/>
						</div>
					</Grid>
					<Grid size={{ xs: 12, md: 12 }}>
						<CheckBoxCustom
							name="bridalPartyMembersGoingDownAisleOneAtATime"
							id="bridalPartyMembersGoingDownAisleOneAtATime"
							lineColor="#8692a4"
							label={
								<span
									style={{
										marginTop: '2px',
										display: 'inline-block',
									}}
								>
									Bridal party members going down aisle one at
									a time
								</span>
							}
							value={
								ceremonyData.bridalPartyMembersGoingDownAisleOneAtATime
							}
							onChange={(e) =>
								setCeremonyData({
									...ceremonyData,
									bridalPartyMembersGoingDownAisleOneAtATime:
										e.target.value,
								})
							}
						/>
					</Grid>
					<Grid size={{ xs: 12, md: 12 }}>
						<div className={styles.checkFormField}>
							<Typography variant="h4">Room Turnover</Typography>
							<ul>
								<li>
									<CheckBoxCustom
										name="ceremonyAndReceptionInSameRoom"
										id="ceremonyAndReceptionInSameRoom"
										lineColor="#ffffffb0"
										label={
											<span
												style={{
													marginTop: '2px',
													display: 'inline-block',
												}}
											>
												Ceremony and reception in the
												same room
											</span>
										}
										value={
											ceremonyData.ceremonyAndReceptionInSameRoom
										}
										onChange={(e) =>
											setCeremonyData({
												...ceremonyData,
												ceremonyAndReceptionInSameRoom:
													e.target.value,
											})
										}
									/>
								</li>
								<li>
									<CheckBoxCustom
										name="rainContingencyPlan"
										id="rainContingencyPlan"
										lineColor="#ffffffb0"
										label={
											<span>
												Rain contingency plan needed
											</span>
										}
										value={ceremonyData.rainContingencyPlan}
										onChange={(e) =>
											setCeremonyData({
												...ceremonyData,
												rainContingencyPlan:
													e.target.value,
											})
										}
									/>
								</li>
							</ul>
						</div>
					</Grid>
				</Grid>
			</div>
		</>
	)
}

export default CeremonyModal
